import { render, staticRenderFns } from "./DeviceInstall.vue?vue&type=template&id=a60c8c4c"
import script from "./DeviceInstall.vue?vue&type=script&lang=js"
export * from "./DeviceInstall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports